import * as React from "react";
import {Link} from "react-router-dom";
import styled from "styled-components";
import {ConstBreakPoint, ConstColor,} from "../../../../config/styles_const/styles_const";
import {OuterURL} from "../../../../config/view_const/outer_url";
import OuterLink from "../../atom/outer_link";
import ParagraphSup from "../../atom/text/paragraph_sup";
import {Li, LiberaInc, Title, Ul} from "./share/footer_components";

interface IProps {
}

const ClientFooter: React.FC<IProps> = (props) => {
    const {} = props;

    return (
        <Wrapper>
            <Area area={"mypage"}>
                <Title bold={true}>マイページ</Title>
            </Area>
            <Area area={"mypageInfo"}>
                <Ul>
                    <Li>
                        <Link to="/client/projects">
                            <ParagraphSup>案件管理</ParagraphSup>
                        </Link>
                    </Li>
                    <Li>
                        <Link to="/client/project/create/new">
                            <ParagraphSup>新規募集作成</ParagraphSup>
                        </Link>
                    </Li>
                    <Li>
                        <Link to="/client/mypage/client">
                            <ParagraphSup>プロフィール</ParagraphSup>
                        </Link>
                    </Li>
                    <Li>
                        <Link to="/client/mypage/company">
                            <ParagraphSup>会社情報</ParagraphSup>
                        </Link>
                    </Li>
                    <Li>
                        <Link to="/client/billing/plan">
                            <ParagraphSup>プラン</ParagraphSup>
                        </Link>
                    </Li>
                    <Li>
                        <Link to="/client/mypage/password">
                            <ParagraphSup>パスワード再設定</ParagraphSup>
                        </Link>
                    </Li>
                    <Li>
                        <Link to="/client/mypage/email">
                            <ParagraphSup>メールアドレス再設定</ParagraphSup>
                        </Link>
                    </Li>
                    <Li>
                        <Link to="/logout">
                            <ParagraphSup>ログアウト</ParagraphSup>
                        </Link>
                    </Li>
                </Ul>
            </Area>
            <Area area={"service"}>
                <Title bold={true}>サービスに関して</Title>
            </Area>
            <Area area={"serviceInfo"}>
                <Ul>
                    <Li>
                        <OuterLink
                            href={OuterURL.clientTermURL}
                            target="_blank"
                            rel="noopener"
                        >
                            <ParagraphSup>利用規約</ParagraphSup>
                        </OuterLink>
                    </Li>
                    <Li>
                        <OuterLink
                            href={OuterURL.privacyURL}
                            target="_blank"
                            rel="noopener"
                        >
                            <ParagraphSup>プライバシーポリシー</ParagraphSup>
                        </OuterLink>
                    </Li>
                </Ul>
            </Area>
            <Area area={"company"}>
                <Title bold={true}>運営企業に関して</Title>
            </Area>
            <Area area={"companyInfo"}>
                <Ul>
                    <Li>
                        <OuterLink
                            href={OuterURL.companyURL}
                            target="_blank"
                            rel="noopener"
                        >
                            <ParagraphSup>企業概要</ParagraphSup>
                        </OuterLink>
                    </Li>
                    <Li>
                        <OuterLink
                            href={OuterURL.employmentURL}
                            target="_blank"
                            rel="noopener"
                        >
                            <ParagraphSup>採用情報</ParagraphSup>
                        </OuterLink>
                    </Li>
                </Ul>
            </Area>
            <Area area={"inc"}>
                <LiberaInc>© Libera Inc.</LiberaInc>
            </Area>
        </Wrapper>
    );
};

export default ClientFooter;

const template = `
        "mypage     . service     . company     .    "
        "mypageInfo . serviceInfo . companyInfo .    "
        " .          . .           . inc         inc "
    `;

const templateSP = `
    " mypage       "
    " mypageInfo   "
    " service      "
    " serviceInfo  "
    " company      "
    " companyInfo  "
    " inc          "
    `;

const Wrapper = styled.div`
    display: grid;
    grid-template-areas: ${templateSP};
    grid-template-columns: 1fr;
    grid-template-rows: auto auto auto auto auto auto auto;
    grid-column-gap: 0;
    grid-row-gap: 0;
    background-color: ${ConstColor.FooterBg};
    padding: 30px;
    @media screen and (min-width: ${ConstBreakPoint.Default}) {
        padding: 50px 50px 30px 50px;
        grid-template-areas: ${template};
        grid-template-columns: auto 100px auto 100px auto 1fr;
        grid-template-rows: auto 1fr auto;
    }
`;

const Area = styled.div<{ area: string }>`
    grid-area: ${(props) => props.area};
`;



// WEBPACK FOOTER //
// ./src/presentation/common/organism/footer/client_footer.tsx